import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { FaWhatsapp } from "react-icons/fa";
import { GlobalSearch } from './GlobalSearch';
import { LanguageSelector } from './LanguageSelector';

const LOGO_URL = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_7012c185-728e-48dd-a634-a866967c4d91/artifacts/4wto96o3_Indo_Travel_25pct_size.png';

export const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const navLinks = [
    { path: '/', label: 'Home' },
    { 
      path: '/indonesia-journeys', 
      label: 'Indonesia Journeys',
      dropdown: [
        { path: '/tours/bali-luxury-retreat', label: 'Bali Luxury Retreat' },
        { path: '/tours/komodo-liveaboard', label: 'Komodo Liveaboard' }
      ]
    },
    { 
      path: '/worldwide-journeys', 
      label: 'Worldwide Journeys',
      dropdown: [
        { path: '/tours/nepal-spiritual-journey', label: 'Nepal Spiritual Journey' },
        { path: '/tours/bhutan-festival-journey', label: 'Bhutan Festival Journey' },
        { path: '/tours/shanghai-cruise', label: 'Shanghai Cruise' }
      ]
    },
    { path: '/CoffeeCivilization', label: 'Coffee Civilization' },
    { path: '/famtrip', label: 'B2B Famtrip' },
    { path: '/b2b', label: 'B2B Partners' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Plan Your Journey' }
  ];

  const whatsappUrl = "https://wa.me/6281517118799?text=Hello%20Indotravelista,%20I%20would%20like%20to%20inquire%20about%20a%20journey.";

  return (
    <nav style={{
      background: 'rgba(7, 13, 30, 0.95)',
      backdropFilter: 'blur(24px)',
      borderBottom: '1px solid rgba(251, 191, 36, 0.2)',
      padding: '16px 40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
    }}>
      {/* Logo */}
      <Link to="/" style={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none'
      }}>
        <img 
          src={LOGO_URL} 
          alt="Indotravelista" 
          style={{
            height: '60px',
            width: 'auto',
            filter: 'drop-shadow(0 2px 8px rgba(251, 191, 36, 0.2))'
          }}
        />
      </Link>

      {/* Desktop Navigation */}
      <ul style={{
        display: 'flex',
        alignItems: 'center',
        gap: '28px',
        listStyle: 'none',
        margin: 0,
        padding: 0
      }} className="desktop-menu">
        {navLinks.map((link) => (
          <li 
            key={link.path}
            style={{ position: 'relative' }}
            onMouseEnter={() => link.dropdown && setActiveDropdown(link.path)}
            onMouseLeave={() => setActiveDropdown(null)}
          >
            {link.dropdown ? (
              <div>
                <Link 
                  to={link.path} 
                  className="nav-link"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    color: '#F8FAFC',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: 500,
                    letterSpacing: '0.3px',
                    padding: '12px 0',
                    transition: 'color 0.2s ease'
                  }}
                >
                  {link.label}
                  <ChevronDown size={14} />
                </Link>
                {activeDropdown === link.path && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    background: 'rgba(15, 23, 42, 0.95)',
                    backdropFilter: 'blur(16px)',
                    border: '1px solid rgba(251, 191, 36, 0.2)',
                    borderRadius: '12px',
                    minWidth: '240px',
                    padding: '8px 0',
                    marginTop: '8px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
                    zIndex: 1000
                  }}>
                    {link.dropdown.map((item) => (
                      <Link
                        key={item.path}
                        to={item.path}
                        style={{
                          display: 'block',
                          padding: '12px 20px',
                          color: '#E2E8F0',
                          textDecoration: 'none',
                          fontSize: '14px',
                          transition: 'all 0.2s'
                        }}
                        className="dropdown-item"
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link to={link.path} className="nav-link" style={{
                color: '#F8FAFC',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: 500,
                letterSpacing: '0.3px',
                padding: '12px 0',
                transition: 'color 0.2s ease'
              }}>{link.label}</Link>
            )}
          </li>
        ))}
        <li>
          <GlobalSearch />
        </li>
        <li>
          <LanguageSelector />
        </li>
        <li>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #FBBF24 0%, #D4AF37 100%)',
              color: '#070D1E',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 600,
              borderRadius: '9999px',
              transition: 'all 0.3s',
              boxShadow: '0 4px 12px rgba(251, 191, 36, 0.3)'
            }}
            className="whatsapp-btn"
          >
            <FaWhatsapp size={16} />
            WhatsApp Us
          </a>
        </li>
      </ul>

      {/* Mobile Menu Toggle */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          display: 'none',
          color: '#FBBF24'
        }}
        className="mobile-menu-toggle"
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div style={{
          position: 'fixed',
          top: '92px',
          left: 0,
          right: 0,
          background: 'rgba(7, 13, 30, 0.98)',
          backdropFilter: 'blur(24px)',
          borderBottom: '1px solid rgba(251, 191, 36, 0.2)',
          padding: '20px 40px',
          zIndex: 99,
          maxHeight: '80vh',
          overflowY: 'auto'
        }} className="mobile-menu">
          <ul style={{
            listStyle: 'none',
            margin: 0,
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link 
                  to={link.path} 
                  className="nav-link" 
                  onClick={() => setIsMenuOpen(false)}
                  style={{ display: 'block', padding: '8px 0', color: '#F8FAFC' }}
                >
                  {link.label}
                </Link>
                {link.dropdown && (
                  <ul style={{
                    listStyle: 'none',
                    margin: '8px 0 0 16px',
                    padding: 0
                  }}>
                    {link.dropdown.map((item) => (
                      <li key={item.path}>
                        <Link
                          to={item.path}
                          onClick={() => setIsMenuOpen(false)}
                          style={{
                            display: 'block',
                            padding: '6px 0',
                            fontSize: '13px',
                            color: '#CBD5E1',
                            textDecoration: 'none'
                          }}
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
            <li style={{ marginTop: '12px' }}>
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '12px 20px',
                  background: 'linear-gradient(135deg, #FBBF24 0%, #D4AF37 100%)',
                  color: '#070D1E',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: 600,
                  justifyContent: 'center',
                  borderRadius: '9999px'
                }}
              >
                <FaWhatsapp size={16} />
                WhatsApp Us
              </a>
            </li>
          </ul>
        </div>
      )}

      <style>{`
        .nav-link {
          position: relative;
        }
        
        .nav-link:hover {
          color: #FBBF24 !important;
        }
        
        .nav-link:after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 0;
          height: 2px;
          background: #FBBF24;
          transition: width 0.3s ease;
        }
        
        .nav-link:hover:after {
          width: 100%;
        }

        .dropdown-item:hover {
          background: rgba(251, 191, 36, 0.1);
          color: #FBBF24 !important;
        }

        .whatsapp-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(251, 191, 36, 0.5) !important;
        }

        @media (max-width: 1024px) {
          .desktop-menu {
            display: none !important;
          }
          
          .mobile-menu-toggle {
            display: block !important;
          }
        }
      `}</style>
    </nav>
  );
};